import { GlobalAlertConfig } from './globalAlertConfig.type';

let /** @type {?} */ defaultGlobaAlertConfig: GlobalAlertConfig = {
  removeLastIfViewportOverflow: false,
  customContainerClasses: 'anAlertItem__item--theme-material'
};

export default defaultGlobaAlertConfig;

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
